"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ResourcePicker_1 = __importDefault(require("./ResourcePicker"));
exports.default = ResourcePicker_1.default;
